import urlEncode from './urlEncode';
import getRole from './getRole';

export default {
  mixins: [
    urlEncode,
    getRole
  ]
}